import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'defaultProfileImageDisplayer',
  props: {
    firstCharacter: {},
    width: {}
  },
  setup(__props: any) {


const props = __props

const backgroundColor = computed(() => {
    return backgroundColorOptions[Math.floor(Math.random() * backgroundColorOptions.length)]
})

const fontSize = computed(() => {
    // Parse the width value and calculate 50% of it
    const widthValue = parseFloat(props.width)
    const unit = props.width.replace(widthValue.toString(), '')
    return `${widthValue * 0.5}${unit}`
})

const backgroundColorOptions = [
    '#000000', // Pure black
    '#1a1a1a', // Rich black
    '#8B0000', // Dark red
    '#B22222', // Fire brick
    '#DC143C', // Crimson
    '#FF4500', // Orange red
    '#FF6347', // Tomato
    '#FF8C00', // Dark orange
    '#FFA500', // Orange
    '#FFD700', // Gold
    '#9ACD32', // Yellow green
    '#32CD32', // Lime green
    '#228B22', // Forest green
    '#008000', // Green
    '#006400', // Dark green
    '#008B8B', // Dark cyan
    '#00CED1', // Dark turquoise
    '#1E90FF', // Dodger blue
    '#0000CD', // Medium blue
    '#000080', // Navy
    '#4B0082', // Indigo
    '#8A2BE2', // Blue violet
    '#9932CC', // Dark orchid
    '#8B008B', // Dark magenta
    '#FF1493'  // Deep pink
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ backgroundColor: backgroundColor.value, width: props.width, height: props.width }),
    class: "default-profile-image-displayer"
  }, [
    _createElementVNode("p", {
      style: _normalizeStyle({ fontSize: fontSize.value })
    }, _toDisplayString(props.firstCharacter), 5)
  ], 4))
}
}

})